<template>
  <div class="checklist-answer-total-item">
    <div
      class="checklist-answer-total_title"
      :class="{blue:blue,yellow:yellow}"
    >
      <WsTextChip001
        leading-icon="icon-warning-filled"
        :text-label="title"
        icon-xl
        font-size-md
        :red="red"
        :blue="blue"
        :yellow="yellow"
        big
      />
    </div>
    <div class="checklist-answer-total_content">
      <div class="ques-number">
        <p class="gray">
          {{ answerTitle }}
        </p>
        <p>{{ answerNumber }}</p>
      </div>
      <div class="ques-number">
        <p class="gray">
          /
        </p>
        <p class="gray">
          /
        </p>
      </div>
      <div class="ques-number">
        <p class="gray">
          {{ totalTitle }}
        </p>
        <p>{{ totalNumber }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChecklistAnswerTotalItem",
  props: {
    red: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    yellow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    totalTitle: {
      type: String,
      default() {
        return this.$t("總共");
      },
    },
    totalNumber: {
      type: Number,
      default: 0,
    },
    answerTitle: {
      type: String,
      default() {
        return this.$t("合規");
      },
    },
    answerNumber: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/checklist-answer-total-item";
</style>